import { createSlice } from '@reduxjs/toolkit';

import { getShippingItems, updateShipment, uploadPackingList, downloadShippingList, uploadShippingList, saveScheduleQuantities } from '../../apis';

export const GetShippingItems = createSlice({
    name: 'shippingItems',
    initialState: {
        IsLoading: false,
        data : [],
        error: '',
        updateShipmentSuccess: false,
        uploadPackingListSuccess: false,
        shippingListUrl: '',
        uploadShippingListSuccess: '',
        saveScheduleQuantitiesSuccess: ''
    },

    reducers: {
        updateShipmentSuccessState: (state, action) => {
            return {
                ...state,
                updateShipmentSuccess: action.payload
            }
        },
        updateSaveScheduleQuantitiesSuccess: (state, action) => {
            return {
                ...state,
                saveScheduleQuantitiesSuccess: action.payload
            }
        },
        updateUploadPackingListSuccess: (state, action) => {
            return {
                ...state,
                uploadPackingListSuccess: action.payload
            }
        },
        updateUploadShippingListSuccess: (state, action) => {
            return {
                ...state,
                uploadShippingListSuccess: action.payload
            }
        },
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearShippingListUrl: (state, action) => {
            return {
                ...state,
                shippingListUrl: action.payload
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getShippingItems.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getShippingItems.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getShippingItems.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(updateShipment.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(updateShipment.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.data = action.payload.data;
            state.updateShipmentSuccess = true;
        })
        builder.addCase(updateShipment.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(uploadPackingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(uploadPackingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.uploadPackingListSuccess = true;
        })
        builder.addCase(uploadPackingList.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(downloadShippingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(downloadShippingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.shippingListUrl = action.payload.data;
        })
        builder.addCase(downloadShippingList.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(uploadShippingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(uploadShippingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.uploadShippingListSuccess = true;
        })
        builder.addCase(uploadShippingList.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(saveScheduleQuantities.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(saveScheduleQuantities.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.error = '';
            state.saveScheduleQuantitiesSuccess = true;
        })
        builder.addCase(saveScheduleQuantities.rejected, (state, action) => {
            state.error = action.payload.message
            state.IsLoading = false;
        })
    }
})

export const { updateShipmentSuccessState, updateUploadPackingListSuccess, clearErrorState, clearShippingListUrl, updateUploadShippingListSuccess, updateSaveScheduleQuantitiesSuccess } = GetShippingItems.actions
export default GetShippingItems.reducer